<template>
  <div :class="colclass">
    <div class="px-2">
      <d-label v-if="label" :label="label" />
      <div class="row">
        <input
          :class="codclass"
          type="text"
          ref="input"
          :value="value"
          :readonly="readonly"
          :placeholder="placeholder"
          @keydown="getkeydown($event)"
          @input="updateValue($event.target.value)"
        >
        <button :class="btnclass" @click="godetail()">
          <span class="pl-1"><i class="di di-eye"></i></span>
        </button>
      </div>
    </div>
    <modal-auth ref="search"></modal-auth>
  </div>
</template>
<script>
    import { NextApiClient } from '@3cad/nextcore'
    import { bus } from '@store/dau'

    export default {
        components: {
            modalAuth: () => import('@erp/comp/modalAuth')
        },
        props: {
            label: String,
            value: String,
            cols: Number,
            placeholder: String,
            readonly: Boolean,
            small: Boolean,
            large: Boolean,
            noborder: Boolean,
            admins: Boolean,
            users: Boolean,
            shops: Boolean,
            countries: Boolean,
            groups: Boolean,
            brands: Boolean,
            modules: Boolean
        },
        data () {
            return {
                ismodal: false,
                g: {
                    isadmin: false,
                    isshopadmin: false,
                    iscatalogadmin: false,
                    users: [],
                    shops: [],
                    countries: [],
                    groups: [],
                    modules: [],
                    brands: [],
                },
                columns: [{id: 'code', title: 'Add or Remove', w: 1}]
            }
        },
        computed: {
            resauth () {
                var x = this.g
                var out = []
                if (x.isadmin) out.push('ADM')
                if (x.iscatalogadmin) out.push('ACAT')
                if (x.isshopadmin) out.push('ASHOP')
                x.users.forEach(e => { if (e.el.cod) out.push(e.el.cod) })
                x.shops.forEach(e => { if (e.el.cod) out.push(e.el.cod) })
                x.groups.forEach(e => { if (e.el.cod) out.push(e.el.cod) })
                x.brands.forEach(e => { if (e.el.cod) out.push(e.el.cod) })
                x.countries.forEach(e => { if (e.el.cod) out.push(e.el.cod) })
                x.modules.forEach(e => { if (e.el.cod) out.push(e.el.cod) })
                return out.join(';')
            },
            codclass () {
                return 'col connectright' + this.getsize()
            },
            btnclass () {
                var aa = 'btn btn-outline-secondary connectleft '
                return aa + this.getsize()
            },
            colclass () {
                if (this.cols && Number.isInteger(this.cols) && this.cols > 0 && this.cols < 13)
                    return 'col-' + this.cols
                else
                    return 'col'
            }
        },
        methods: {
            openModal () {
                this.$refs.search.open({
                    title: !this.label ? this.$parent.$parent.title : this.label, // this.label,
                    //  resauth: this.getresauth(), // this.value,
                    g: this.g,
                    admins: this.admins,
                    users: this.users,
                    shops: this.shops,
                    countries: this.countries,
                    groups: this.groups,
                    brands: this.brands,
                    modules: this.modules
                }).$once('close', (mode, data) => {
                    if (mode < 1)
                        return
                    this.updateValue(data)
                })
            },
            addelement (e) {
                // importante impostare il vettore all'inizio!
                e.el = {}
            },
            getsearch (n) {
                return {
                    service: 'cSearch',
                    func: 'AuthSearch',
                    params: {
                        auth: n
                    }
                }
            },
            close (e) {
                this.ismodal = false
                this.$emit('input', this.resauth)
            },
            godetail () {
                var value = this.getmodule()
                NextApiClient.com('cSearch', 'jAuth', {auth: value}, d => {
                    // devo inserire il vettore all'interno di un oggetto altrimenti non lo posso editare!
                    d.modules.forEach(e => e.cod = e.cod.substr(1))
                    this.g.isadmin = d.isadmin
                    this.g.isshopadmin = d.isshopadmin
                    this.g.iscatalogadmin = d.iscatalogadmin
                    this.g.users = []
                    this.g.shops = []
                    this.g.countries = []
                    this.g.groups = []
                    this.g.modules = []
                    this.g.brands = []
                    d.users.forEach(e => this.g.users.push({el: e}))
                    d.shops.forEach(e => this.g.shops.push({el: e}))
                    d.countries.forEach(e => this.g.countries.push({el: e}))
                    d.groups.forEach(e => this.g.groups.push({el: e}))
                    d.modules.forEach(e => this.g.modules.push({el: e}))
                    d.brands.forEach(e => this.g.brands.push({el: e}))
                    this.ismodal = true
                    this.openModal()
                })
            },
            getkeydown (e) {
                var sc = this
                switch (e.key) {
                    case '?':
                        e.preventDefault()
                        this.godetail()
                        break
                    case 'Enter':
                        break
                }

            },
            updateValue (v) {
                this.$emit('input', v)
            },
            dofollow () {
                var sc = this
                bus.$emit('routeadd', {cod: sc.follow})
            },
            getsize () {
                var aa = this.noborder ? ' noborder' : ''
                return this.small ? aa + ' small' : this.large ? aa + ' large' : ''
            },
            getmodule () {
                if (!this.value) return
                var modulelist = this.value.split(';')
                var _modulelist = []
                var s = ''
                // if (this.admins) {s = 'A'}
                // if (this.users) {s = 'U'}
                // if (this.shops) {s = 'S'}
                // if (this.countries) {s = 'C'}
                // if (this.groups) {s = 'G'}
                // if (this.brands) {s = 'B'}
                // if (this.modules) {s = 'M'}
                modulelist.forEach(e => _modulelist.push(e.slice(0, 0) + ((e !== 'ADM' && e !== 'ACAT' && e !== 'ASHOP') ? s : '') + e.slice(0)))
                return _modulelist.join(';')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/_eng/globals/dauth.vue